import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/notifications';

class NotificationService {
    async getNotifications(id) {
        try {
            return axios.get(`${API_URL}/user/${id}`);
        } catch (error) {
            console.error('Błąd podczas pobierania powiadomień:', error);
        }
    }
    async markAsRead(id, notifications) {
        try {
            // Wywołanie API przy użyciu axios do oznaczenia powiadomienia jako przeczytane
            await axios.patch(`${API_URL}/${id}/read`);

            // Zwraca nową listę powiadomień, z której usunięto przeczytane powiadomienie
            return notifications.filter(notification => notification.id !== id);
        } catch (error) {
            console.error('Błąd podczas oznaczania powiadomienia jako przeczytane:', error);
            throw error; // Rzuca błąd, aby móc go obsłużyć w komponencie, jeśli jest potrzebna obsługa błędów
        }
    }

    async markAllAsRead() {
        try {
            await axios.patch(`${API_URL}/mark-all-read`);
        } catch (error) {
            console.error('Błąd podczas oznaczania wszystkich powiadomień jako przeczytane:', error);
            throw error;
        }
    }

    async reportBreakdown(driverId) {
        try {
            await axios.post(`${API_URL}/create-driver-reported-breakdown/${driverId}`);
        } catch (error) {
            console.error('Błąd podczas oznaczania wszystkich powiadomień jako przeczytane:', error);
            throw error;
        }
    }

    async deleteNotificationForUser(notificationId, userId) {
        try {
            await axios.delete(`${API_URL}/${notificationId}/user/${userId}`);
        } catch (error) {
            console.error('Błąd podczas usuwania powiadomienia:', error);
            throw error;
        }
    }

    async deleteAllNotifications(userId) {
        try {
            await axios.delete(`${API_URL}/delete/user/${userId}`);
        } catch (error) {
            console.error('Błąd podczas usuwania powiadomień:', error);
            throw error;
        }
    }
}

export default new NotificationService();
